import { useState, useEffect, useCallback } from 'react';

let deferredPrompt = null;
const listeners = new Set();

if (typeof window !== 'undefined') {
  window.addEventListener('beforeinstallprompt', (e) => {
    e.preventDefault();
    deferredPrompt = e;
    listeners.forEach((fn) => fn());
  });
  window.addEventListener('appinstalled', () => {
    deferredPrompt = null;
    listeners.forEach((fn) => fn());
  });
}

const isStandalone = () =>
  window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone === true;

const isIOS = () =>
  /iphone|ipad|ipod/i.test(navigator.userAgent) ||
  (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);

export const useInstallPrompt = () => {
  const [, force] = useState(0);
  const [installed, setInstalled] = useState(isStandalone());

  useEffect(() => {
    const update = () => { force((n) => n + 1); setInstalled(isStandalone()); };
    listeners.add(update);
    return () => listeners.delete(update);
  }, []);

  const promptInstall = useCallback(async () => {
    if (!deferredPrompt) return false;
    deferredPrompt.prompt();
    const { outcome } = await deferredPrompt.userChoice;
    deferredPrompt = null;
    force((n) => n + 1);
    return outcome === 'accepted';
  }, []);

  const ios = isIOS();
  return {
    installed,
    ios,
    canPrompt: !!deferredPrompt,
    available: !installed && (!!deferredPrompt || ios),
    promptInstall,
  };
};

export default useInstallPrompt;
